import { render } from "./OurServices.vue?vue&type=template&id=34f09c14&scoped=true"
const script = {}

import "./OurServices.vue?vue&type=style&index=0&id=34f09c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f09c14"]])

export default __exports__